export const tabStyleSx = () => ({
  '& .MuiTab-root': {
    padding: '8px 12px',
  },
});
